import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule, NgbTooltipModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';

import { TenantRoutingModule } from './tenant-routing.module';

import { HomeComponent } from './home/home.component';
import { StatusRendererComponent } from './status/status-renderer.component';
import { CreateTenantModalComponent } from './modals/create-tenant-modal/create-tenant-modal.component';
import { DetailsComponent } from './details/details.component';
import { DeleteTenantConfirmationModalComponent } from './modals/delete-tenant-confirmation-modal/delete-tenant-confirmation-modal.component';
import { DeleteTenantModalComponent } from './modals/delete-tenant-modal/delete-tenant-modal.component';
import { TenantJobModalComponent } from './modals/tenant-job-modal/tenant-job-modal.component';
import { DeleteSurveyModalComponent } from './modals/delete-survey-modal/delete-survey-modal.component';
import { DeleteSurveyConfirmationModalComponent } from './modals/delete-survey-confirmation-modal/delete-survey-confirmation-modal.component';
import { DeleteTenantDataModalComponent } from './modals/delete-tenant-data-modal/delete-tenant-data-modal.component';
import { DeleteTenantDataConfirmationModalComponent } from './modals/delete-tenant-data-confirmation-modal/delete-tenant-data-confirmation-modal.component';



@NgModule({
  declarations: [
    HomeComponent,
    StatusRendererComponent,
    CreateTenantModalComponent,
    DetailsComponent,
    DeleteTenantConfirmationModalComponent,
    DeleteTenantModalComponent,
    TenantJobModalComponent,
    DeleteSurveyModalComponent,
    DeleteSurveyConfirmationModalComponent,
    DeleteTenantDataModalComponent,
    DeleteTenantDataConfirmationModalComponent
  ],
  imports: [
    CommonModule,
    TenantRoutingModule, 
    NgbModule,
    FormsModule,
    ReactiveFormsModule,   
    AgGridModule.withComponents([]),
    SharedModule.forRoot()
  ],
  entryComponents: [
    CreateTenantModalComponent
  ]
})
export class TenantModule { }
